exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\r\n    margin: 0px;\r\n    padding: 0px;\r\n    list-style-type: none;\r\n}\r\n\r\n\r\nli {\r\n    box-sizing: border-box;\r\n    display: block;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 50px;\r\n    vertical-align: middle;\r\n    text-decoration: none;\r\n    transition: all .3s;\r\n    position: relative;\r\n    padding-left: 50px;\r\n    color: rgb(255,255,255);\r\n}\r\n\r\nli a {\r\n    color: rgb(255,255,255);\r\n}\r\n\r\n.menu-item {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    border-bottom-style: solid;\r\n    border-width: 1px;\r\n    border-color: rgb(62,62,62);\r\n}\r\n\r\n.menu-text {\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 50px;\r\n    height: 50px;\r\n    vertical-align: middle;\r\n    text-decoration: none;\r\n    position: relative;\r\n    color: rgb(170,170,170);\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;    \r\n}\r\n\r\n.menu-text a {\r\n    color: rgb(170,170,170);\r\n\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/left-menu.component.css
// module id = 191
// module chunks = 0